import { createActions } from 'redux-actions';
import _ from 'lodash';

import { actionTypes } from './actionTypes';
import { breadCrumbMap } from '../../container/routes';
import { API } from '@service';
import actions from '@flux/action/index';
import { ProjectInfoRequestManager } from '@service/apis';
import { setSessionStorage, getSessionStorage } from '@utils/windowUtil';

const commonActions = createActions({}, ...Object.values(actionTypes.common));

const isAtSystemSetting = (breads = []) =>
  breads.filter((b) => b.breadcrumbName === 'System Settings').length > 0;

const matchBreadCrumb = (projectName) => (dispatch, getState) => {
  const currentPath = window.location.pathname;
  const currentSearch = window.location.search;
  const searchParams = new URLSearchParams(currentSearch);
  const fromTiles = searchParams.get('from') === 'tiles';
  const tempProjectName =
    projectName || getSessionStorage('projectName') || null;
  const isProjectList = window.location.pathname === '/gateway/projects/list';
  // const instanceType = getState().common.projectCompanyInfo.instanceType;
  const newRoutes = getState().common.newRoutes;
  const analysisPermissionTemplate =
    getState().projects?.customizedModules?.find(
      (i) => i.value === 'analysis',
    )?.originPermissions;
  const insightsPermissionTemplate =
    getState().projects?.customizedModules?.find(
      (i) => i.value === 'insight',
    )?.originPermissions;
  const analysisRoute =
    analysisPermissionTemplate?.map((i) => ({
      path: `/analysis/${i.value}`,
      breadcrumbName: i.label,
    })) || [];
  const insightsRoute =
    insightsPermissionTemplate?.map((i) => ({
      path: `/insights/${i.value}`,
      breadcrumbName: i.label,
    })) || [];
  const newBreadCrumb = breadCrumbMap(newRoutes || '')
    .concat(analysisRoute)
    .map((item) => {
      if (
        item.path === '/insights/guidingPrinciples' &&
        currentPath === '/gateway/insights/guidingPrinciples-divestitures'
      ) {
        return null;
      }

      if (
        item?.isCustomizedModule &&
        `${currentPath}${currentSearch}`.includes(item.path)
      ) {
        return item;
      }

      if (!item?.isCustomizedModule && currentPath.includes(item.path)) {
        if (item.path.includes('/insights/')) {
          const targetInsightRoute = insightsRoute.find(
            (i) => i.path === item.path,
          );
          if (targetInsightRoute) {
            item.breadcrumbName = targetInsightRoute.breadcrumbName;
          }
        }
        return item;
      }

      return null;
    });

  let finalBreadCrumb = _.compact(newBreadCrumb);

  tempProjectName !== null &&
    !isAtSystemSetting(finalBreadCrumb) &&
    !isProjectList &&
    finalBreadCrumb.splice(1, 0, {
      breadcrumbName: tempProjectName,
      path: `/project-detail/${getSessionStorage('currentId')}`,
    });

  if (fromTiles) {
    finalBreadCrumb.push(
      {
        path: `/project-detail/${getSessionStorage('currentId')}`,
        breadcrumbName: 'Project Home',
      },
      {
        breadcrumbName: searchParams.get('moduleName'),
        path: `/projects/list`,
      },
    );
  }

  finalBreadCrumb = finalBreadCrumb.filter((e) => e.path !== '/projects');
  // let key;
  // for (key in finalBreadCrumb) {
  //   if (finalBreadCrumb[key].path === '/insights/maturityAssessment')
  //     finalBreadCrumb[key].breadcrumbName = `${
  //       instanceType === 'Integration'
  //         ? 'Integration '
  //         : instanceType === 'Divestiture'
  //         ? 'Separation '
  //         : ' '
  //     }Readiness Assessment`;
  //
  //   if (finalBreadCrumb[key].path === '/insights/guidingPrinciples')
  //     finalBreadCrumb[key].breadcrumbName =
  //       instanceType !== 'Customize'
  //         ? finalBreadCrumb[key].breadcrumbName
  //         : 'Guiding Principles';
  // }
  dispatch(commonActions.changeBreadcrumb(finalBreadCrumb));
};

const addBreadCrumb =
  (newItem = {}) =>
  (dispatch, getState) => {
    const currentBread = [...getState().common.breadcrumb];

    const lastBread = currentBread[currentBread.length - 1] || {};

    if (Array.isArray(newItem)) {
      if (newItem[newItem.length - 1].path?.includes(lastBread.path)) {
        currentBread.pop();
      }
      return dispatch(
        commonActions.changeBreadcrumb([...currentBread, ...newItem]),
      );
    }

    if (newItem.path?.includes(lastBread.path)) {
      currentBread.pop();
    }

    const finalBreadCrumb = [...currentBread, newItem];
    dispatch(commonActions.changeBreadcrumb(finalBreadCrumb));
  };

const getConfig = () => async (dispatch) => {
  const configMeta = await API.getConfig();
  const adminList = await API.getAdminList();
  const config = Object.keys(configMeta).reduce((acc, k) => {
    const fieldValue = { [k]: configMeta[k] };
    if (k === 'colors' && typeof configMeta[k] === 'string') {
      fieldValue[k] = configMeta[k].split(',');
    }
    return Object.assign(acc, fieldValue);
  }, {});
  config.adminList = adminList;
  dispatch(commonActions.changeConfig(config));
};

const getProjectInfo = (projectId) => async (dispatch) => {
  // dispatch(actions.changeLoading(true));
  try {
    dispatch(commonActions.changeProjectInfoLoading(true));
    const result = await API.getProjectCompaniesInfoRequest(projectId);

    // 解决从列表直接点击project settings导致报错问题
    // if (!result || window.location.pathname?.includes('projects/list')) return;
    if (!result) {
      return;
    }
    // if (!result) return;
    dispatch(commonActions.changeProjectInfo(result));
    if (result?.theme) {
      dispatch(actions.changeTheme(result.theme));
    }
    if (result?.projectName) {
      // to prevent missing project name in breadcrumb
      dispatch(actions.matchBreadCrumb(result.projectName));
      setSessionStorage('projectName', result.projectName);
    }
  } catch (e) {
    console.log(e);
  }
  dispatch(commonActions.changeProjectInfoLoading(false));
};

const popReportIssueModal = (defaultValues) => (dispatch) => {
  dispatch(commonActions.changeReportIssueValues(defaultValues || {}));
  dispatch(commonActions.toggleReportIssueModal(true));
};

const changeCurrentId = (newProjectId) => (dispatch, getState) => {
  const prevProjectId = getState().common.currentId;

  if (prevProjectId === newProjectId) {
    return;
  }

  // console.log('projectChange', `${prevProjectId} -> ${newProjectId}`);

  if (prevProjectId !== null && prevProjectId !== newProjectId) {
    ProjectInfoRequestManager.changeCurReqId(newProjectId);
    dispatch(actions.resetProjectData());
  }
  dispatch(actions.changeCurrentIdState(newProjectId));
};

const getSystemColorTheme = () => async (dispatch, getState) => {
  try {
    dispatch(actions.changeSystemThemeLoading(true));
    const result = await API.getSystemColorTheme();
    if (result?.config?.value) {
      window.localStorage.setItem('systemTheme', result?.config?.value);
      dispatch(actions.changeSystemTheme(result?.config?.value));
    }
  } catch (e) {
    console.log(e);
  }
  dispatch(actions.changeSystemThemeLoading(false));
};

const changeSystemColorTheme = (theme) => async (dispatch) => {
  dispatch(actions.changeSystemThemeLoading(true));
  const result = await API.updateSystemColorTheme(theme);
  if (result) {
    dispatch(actions.changeSystemTheme(theme));
    window.localStorage.setItem('systemTheme', theme);
  }
  dispatch(actions.changeSystemThemeLoading(false));
};

const setEmailVerifyModalRef = (ref) => (dispatch) => {
  dispatch(commonActions.setEmailVerifyModalRef(ref));
};

export default {
  ...commonActions,
  matchBreadCrumb,
  getConfig,
  addBreadCrumb,
  getProjectInfo,
  popReportIssueModal,
  changeCurrentId,
  getSystemColorTheme,
  changeSystemColorTheme,
  setEmailVerifyModalRef,
};
